/**
 * Get feature-toggle from window.HN.
 * @param featureName name of feature
 */
export default function getFeatureToggle(featureName) {
    const getFeatureToggles = window.HN?.PortalCommands?.GetFeatureToggles || window.HN?.Commands?.GetFeatureToggles;
    return !!getFeatureToggles?.FeatureToggles?.[featureName];
}
